var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"errors":_vm.errors,"form":_vm.value,"loading":_vm.loading,"save":_vm.save})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }